import React from 'react';
import './DataTableBulkActions.scss';
import { Button } from '@livingdesign/react';
import { Check } from '@livingdesign/icons';

export const QA_ID_PREFIX = 'DataTableBulkActions';

function DataTableBulkActions({ 
  selectedCount = 0, 
  onSelectAll,
  onClearSelection,
  onApply,
  primaryActionLabel = "Apply to message"
}) {
  if (selectedCount === 0) {
    return null;
  }

  return (
    <div className="datatable-bulk-actions" data-testid={`${QA_ID_PREFIX}-wrapper`}>
      <div className="datatable-bulk-actions-content" data-testid={`${QA_ID_PREFIX}-content`}>
        {/* Left Section - Selection Info */}
        <div className="datatable-bulk-actions-info" data-testid={`${QA_ID_PREFIX}-info`}>
          <div className="datatable-bulk-actions-icon" data-testid={`${QA_ID_PREFIX}-icon`}>
            <Check size="large" />
          </div>
          <div className="datatable-bulk-actions-text" data-testid={`${QA_ID_PREFIX}-text`}>
            <span className="datatable-bulk-actions-count" data-testid={`${QA_ID_PREFIX}-count`}>
              {selectedCount} row{selectedCount !== 1 ? 's' : ''}
            </span>
            <span className="datatable-bulk-actions-selected" data-testid={`${QA_ID_PREFIX}-selected`}>
              selected
            </span>
          </div>
        </div>

        {/* Middle Section - Global Select Actions */}
        <div className="datatable-bulk-actions-links" data-testid={`${QA_ID_PREFIX}-links`}>
          {onSelectAll && (
            <Button
              variant="link"
              size="small"
              onClick={onSelectAll}
              data-testid={`${QA_ID_PREFIX}-select-all-button`}
            >
              Select all
            </Button>
          )}
          
          {onClearSelection && (
            <Button
              variant="link"
              size="small"
              onClick={onClearSelection}
              data-testid={`${QA_ID_PREFIX}-clear-button`}
            >
              {onSelectAll ? 'Clear selected' : 'Clear selection'}
            </Button>
          )}
        </div>

        {/* Right Section - Primary Action */}
        <div className="datatable-bulk-actions-primary" data-testid={`${QA_ID_PREFIX}-primary`}>
          {onApply && (
            <Button
              variant="primary"
              size="small"
              onClick={onApply}
              data-testid={`${QA_ID_PREFIX}-apply-button`}
            >
              {primaryActionLabel}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}

export default DataTableBulkActions;
